import { render, staticRenderFns } from "./ContratoLicencaLista.vue?vue&type=template&id=52e521e6&"
import script from "./ContratoLicencaLista.vue?vue&type=script&lang=js&"
export * from "./ContratoLicencaLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports